import { render, staticRenderFns } from "./PlatformChannelCard.vue?vue&type=template&id=3d2a5a33&scoped=true"
import script from "./PlatformChannelCard.vue?vue&type=script&lang=js"
export * from "./PlatformChannelCard.vue?vue&type=script&lang=js"
import style0 from "./PlatformChannelCard.vue?vue&type=style&index=0&id=3d2a5a33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2a5a33",
  null
  
)

export default component.exports